import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import Modal from 'components/shared/modal';

const ErrorAlert = ({ hasError }) => {
  const modalConfig = {
    type: 'confirm',
    show: hasError,
    center: true,
    message: (
      <p>
        {t('common.problem.saving_update')}
        <br />
        {t('common.solution.reload_try_again')}
      </p>
    ),
    confirmButtonText: t('common.reload_page'),
    onConfirm() {
      window.location.reload();
    },
  };

  const imageUrl = useMemo(() => {
    // This is only added to pre-load the image in case the error modal
    // toggled because of a connection issue (e.g. offline network) that could
    // potentially prevent the image from loading.
    const image = new Image();
    image.src = '/assets/blankslates/editor_error.svg';
    return image.src;
  }, []);

  return (
    <Modal className="Editor-ErrorModal" {...modalConfig}>
      <img
        src={imageUrl}
        role="presentation"
        alt={t('lessons.editor.error_message')}
      />
      <h3>{t('common.uh_oh')}</h3>
    </Modal>
  );
};

const mapStateToProps = state => ({
  hasError: !state.editor.success,
});

export default connect(mapStateToProps)(ErrorAlert);
